import { Breakpoint, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export function useIsDown(breakpoint: Breakpoint, screenOnly = false) {
  const theme = useTheme();
  const inputQuery = screenOnly
    ? `@media screen and (max-width:${
        theme.breakpoints.values[breakpoint] - 0.05
      }px)`
    : theme.breakpoints.down(breakpoint);
  return useMediaQuery(inputQuery);
}

export function useIsUp(breakpoint: Breakpoint, screenOnly = false) {
  const theme = useTheme();
  const inputQuery = screenOnly
    ? `@media screen and (min-width:${
        theme.breakpoints.values[breakpoint] - 0.05
      }px)`
    : theme.breakpoints.up(breakpoint);
  return useMediaQuery(inputQuery);
}

type MediaResolution = {
  max?: number;
  min?: number;
};

export function useIsResolution(resolution: MediaResolution) {
  const { max, min } = resolution;
  let inputQuery = '@media screen and ';
  if (min) inputQuery = `${inputQuery}(min-width: ${min}px)`;
  if (min && max) inputQuery = `${inputQuery} and `;
  if (max) inputQuery = `${inputQuery}(max-width: ${max}px)`;
  return useMediaQuery(inputQuery);
}
